import { goGlobalToken } from '../../config';
import { handleError, checkIfJson } from '../../errorHandler';


export function logintoSQL(emailParam, passwordParam) {
  return fetch('/api/v1/loginSQL', {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': goGlobalToken.go_token,
    },
    method: 'POST',
    body: JSON.stringify({ email: emailParam, password: passwordParam }),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error(`status ${response.status}`);
      }
      return response.json();
    }).then(json => checkIfJson(json)).catch((e) => {
      handleError(`signin_api: login API call failed : ${e}`);
      return `API call failed: ${e}`;
    });
}

export function logintoSQLSuccessLoadUser(token, email_session) {
  localStorage.setItem('JWT_TOKEN', token);
  localStorage.setItem('user', email_session);

  return fetch('/api/v1/getUserSQL', {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token,
    },
    method: 'POST',
    body: JSON.stringify({ email: email_session }),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error(`status ${response.status}`);
      }
      return response.json();
    }).then(json => checkIfJson(json)).catch((e) => {
      handleError(`Signin_api: getUser API call failed : ${e}`);
      return {
        code: 500,
        failed: 'error ocurred',
      };
    });
}


export function logintoSQLSuccessLoadCompany(token, company_obj) {
  return fetch('/api/v1/getCompanySQL', {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token,
    },
    method: 'POST',
    body: JSON.stringify({ company_obj }),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error(`status ${response.status}`);
      }
      return response.json();
    }).then(json => checkIfJson(json)).catch((e) => {
      handleError(`signin_api: getCompany API call failed : ${e}`);
      return {
        code: 500,
        failed: 'error ocurred',
      };
    });
}


export function logintoSQLSuccessLoadWorkforce(token, company_obj) {
  return fetch('/api/v1/getWorkforceSQL', {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token,
    },
    method: 'POST',
    body: JSON.stringify({
      company_obj,
      all_for_company: true,
      email: '',
    }),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error(`status ${response.status}`);
      }
      return response.json();
    }).then(json => checkIfJson(json)).catch((e) => {
      handleError(`signin_api: getWorkforce API call failed : ${e}`);
      return {
        code: 500,
        failed: 'error ocurred',
      };
    });
}



// WEBPACK FOOTER //
// ./src/containers/Page/signin_api.js